class EventBus {
  private events;
  private latestValues;

  constructor() {
    this.events = {};
    this.latestValues = {};
  }

  on(event, listener) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);

    // If there's a latest value for this event, immediately invoke the listener with it
    if (this.latestValues.hasOwnProperty(event)) {
      listener(this.latestValues[event]);
    }
  }

  off(event, listenerToRemove) {
    if (!this.events[event]) return;

    this.events[event] = this.events[event].filter(listener => listener !== listenerToRemove);
  }

  emit(event, data) {
    this.latestValues[event] = data;

    if (!this.events[event]) return;

    console.log(`emitting ${event}`)

    this.events[event].forEach(listener => listener(data));
  }

  getLatestValue(event) {
    return this.latestValues[event];
  }

}

// Create a singleton instance of EventBus
export const eventBus = new EventBus();
